import store from "../../../store";

export default [
  {
    path: "/guiches-info",
    name: "guichesInfos",
    component: () => import(/*webpackChunckName: "registerQueues" */ "./guiches.vue"),
    beforeEnter: (to, from, next) => {
      if (store.getters["auth/hasRole"] === "admin") {
        next();
      } else {
        next({ name: "attendance" });
      }
    },
  },
];
